import { render, staticRenderFns } from "./uploadResume.vue?vue&type=template&id=b8af0a62&scoped=true"
import script from "./uploadResume.vue?vue&type=script&lang=js"
export * from "./uploadResume.vue?vue&type=script&lang=js"
import style0 from "./uploadResume.vue?vue&type=style&index=0&id=b8af0a62&prod&lang=scss&scoped=true"
import style1 from "./uploadResume.vue?vue&type=style&index=1&id=b8af0a62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8af0a62",
  null
  
)

export default component.exports